import { Link } from "react-router-dom";
import { Button } from "@/components/uiDir/button";
import { Sparkles } from "lucide-react";
import Favicon from '/public/favicon.ico';

const Navbar = () => {
  return (
    <>
      <nav
        className="fixed left-0 right-0 z-50 bg-background/80 backdrop-blur-lg border-b border-border"
        style={{ top: "var(--beta-banner-height)" }}
      >
        <div className="container mx-auto px-4 sm:px-6 h-14 sm:h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-heading text-lg sm:text-xl font-bold">
            {/* <img src={Favicon} alt="Favicon" className="h-6 w-6 rounded-full object-contain text-primary" /> */}
            <span className="bg-gradient-to-r bg-clip-text text-primary">
              PortfolioHub
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            <Link to="/#features" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
              Features
            </Link>
            <Link to="/#how-it-works" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
              How It Works
            </Link>
            <Link to="/explore" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
              Explore
            </Link>
          </div>

          <div className="flex items-center gap-2 sm:gap-3">
            <Link to="/login">
              <Button
                variant="ghost"
                size="sm"
                className="h-8 px-3 text-xs sm:h-9 sm:px-4 sm:text-sm"
              >
                Log In
              </Button>
            </Link>
            <Link to="/signup">
              <Button
                variant="gradient"
                size="sm"
                className="h-8 px-3 text-xs sm:h-9 sm:px-4 sm:text-sm"
              >
                Get Started
              </Button>
            </Link>
          </div>
        </div>
      </nav>
      <div style={{ height: "calc(var(--beta-banner-height) + var(--navbar-height))" }} />
    </>
  );
};

export default Navbar;
